export default __webpack_public_path__ + "static/media/image_watermark.d884a014.svg";